import { useState } from 'react'
import { Bell } from 'lucide-react'
import { Popover } from './primitives/Popover'
import { ReminderOptions } from './reminder/ReminderOptions'
import type { Todo } from '../api/types'

interface ReminderPickerProps {
  todo: Todo
}

/** Desktop bell: a popover shell around the shared reminder menu. */
export function ReminderPicker({ todo }: ReminderPickerProps) {
  const [open, setOpen] = useState(false)
  const hasReminder = !!todo.reminder_at || !!todo.reminder_time

  const title = todo.reminder_at
    ? `Reminder: ${new Date(todo.reminder_at).toLocaleString()}`
    : todo.reminder_time
      ? `Reminder: ${todo.reminder_time}${todo.reminder_day_offset === -1 ? ' the day before' : ''}`
      : 'Add reminder'

  const trigger = (
    <button
      title={title}
      className='todo-reminder-btn'
      onPointerDown={(e) => e.stopPropagation()}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        color: hasReminder ? 'var(--color-accent)' : 'var(--color-ink-muted)',
        padding: '0 2px',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Bell size={12} strokeWidth={1.5} />
    </button>
  )

  return (
    <Popover trigger={trigger} align="right" open={open} onOpenChange={setOpen}>
      <div style={{ padding: '12px', minWidth: '220px' }}>
        <ReminderOptions todo={todo} onDone={() => setOpen(false)} />
      </div>
    </Popover>
  )
}
